import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '../../_services/dialog.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BarrelPrinter } from '../../_models/fundraising/BarrelPrinter';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PrinterService } from '../../_services/fundraising/printer.service';

@Component({
  selector: 'app-printer-management',
  templateUrl: './printer-management.component.html',
  styleUrls: ['../../_shared/base.management.component.css']
})

export class PrinterManagementComponent implements OnInit {
  public loading = true;

  public display: BarrelPrinter[];
  public items: BarrelPrinter[];

  public searchText: string;

  private bsModalRef: any;

  constructor(
    private router: Router,
    private printerService: PrinterService,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService) {

  }

  ngOnInit() {
    this.load();
  }

  public search() {
    if (!this.searchText) {
      this.display = this.items;
      return;
    }

    const search = this.searchText.toLowerCase();
    this.display = this.items.filter(p =>
      (p.name ? p.name.toLowerCase().indexOf(search) !== -1 : false) ||
      (p.cue5050?.event.name ? p.cue5050.event.name.toLowerCase().indexOf(search) !== -1 : false) ||
      (p.barrelPrinterId ? p.barrelPrinterId.toString().indexOf(search) !== -1 : false) ||
      !search);

  }

  public delete(id: number) {
    this.dialogService.confirm('Confirm Delete', 'Are you sure you want to delete this printer?', this.viewRef).then(result => {
      if (result) {
        this.loading = true;
        this.spinner.show();

        this.printerService.delete(id)
          .subscribe(
            () => {
              this.spinner.hide();
              this.load();
          }, 
            error => {
              this.spinner.hide();
              this.dialogService.error(
                error, 
                `Unable to delete this printer`,
                this.viewRef);  
          });
      }
    });
  }


  private load() {
    this.spinner.show();

    this.printerService.getAll().subscribe(data => {
      this.display = data;
      this.items = data;

      this.loading = false;
      this.spinner.hide();
    },
    error => {
      this.dialogService.alert(
        'Uh oh something went wrong...', 
        `Unable to load printers: ${error.error}`,
        this.viewRef);

        this.loading = false;
        this.spinner.hide();
    });
  }

  public create() {
    this.router.navigate(['/portal/fundraising/cue5050/printers/create']);
  }

  public edit(id: number) {
    this.router.navigate([`/portal/fundraising/cue5050/printers/update/${id}`]);
  }
}
